module.exports = __webpack_public_path__ + "img/1.e426d779.png";